// extracted by mini-css-extract-plugin
module.exports = {"noPadding":"home_noPadding__XULfo","section":"home_section__yqkNI"};